import React from "react";
import * as PropTypes from "prop-types";
import DataViewerFrame from "../../widgets/DataViewerFrame";
import PrivateSectorPricesByMethodTable from "./PrivateSectorPricesByMethodTable";

const PrivateSectorPricesByMethodTableWidget = props => (
  <DataViewerFrame
    reference="Table 3.1"
    title="Private Sector Prices by Method"
    subtitle="Regional Averages among LMICs"
    onDownloadCsv={props.onDownloadCsv}
  >
    <PrivateSectorPricesByMethodTable na="&#8212;" />
  </DataViewerFrame>
);

PrivateSectorPricesByMethodTableWidget.propTypes = {
  onDownloadCsv: PropTypes.func.isRequired
};

export default PrivateSectorPricesByMethodTableWidget;
